import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './LeadershipSection.css';
import '../common-styles.css';
import nitinImg from '../../assets/images/leadership/nitinshingala.png';
import jagdishImg from '../../assets/images/leadership/jagadishshingala.png';
import prakashImg from '../../assets/images/leadership/prakashshingala.png';

interface Leader { id: number; name: string; title: string; img: string; anchor: string; }

const leaders: Leader[] = [
  { id: 1, name: 'Nitin Shingala', title: 'CEO', img: nitinImg, anchor: 'nitin-shingala' },
  { id: 2, name: 'Jagdish Shingala', title: 'Founder & Chairman', img: jagdishImg, anchor: 'jagdish-shingala' },
  { id: 3, name: 'Prakash Shingala', title: 'CEO', img: prakashImg, anchor: 'prakash-shingala' }
];

const LeadershipSection: React.FC = () => {
  return (
    <section className="leadership-section section">
      <Container>
        <div className="leadership-badge">LEADERSHIPS</div>
        <Row className="align-items-start mb-5 g-4 leadership-header-row">
          <Col lg={6}>
            <h2 className="leadership-heading">
              Crafted by Experts <br />
              <span className="highlight-gradient">Powered by Innovation.</span>
            </h2>
          </Col>
          <Col lg={6}>
            <p className="leadership-intro">
              We don’t just make diamonds — we shape moments, memories, and meaning with every facet we cut.
            </p>

            <Link to="/leadership" style={{ textDecoration: 'none' }}>
              <Button className="section-btn">
                <span className="btn-content">Know More <i className="fas fa-arrow-right ms-2 btn-arrow-diagonal" /></span>
              </Button>
            </Link>
          </Col>
        </Row>

        <Row className="g-4 leadership-cards-row">
          {leaders.map(l => (
            <Col lg={4} md={6} key={l.id} className="d-flex">
              <Link to={`/leadership#${l.anchor}`} className="leader-card-link" aria-label={`View ${l.name} profile`}>
                <div className="leader-simple-card">
                  <div className="leader-photo-wrapper">
                    <img src={l.img} alt={l.name} className="leader-photo" />
                  </div>
                  <div className="leader-card-footer">
                    <div className="leader-meta">
                      <div className="leader-name-text">{l.name}</div>
                      <div className="leader-role-text">{l.title}</div>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default LeadershipSection;
